//================= [JS] ======================================
import {i18n} from '@/common/i18n';
import {Routes} from '@/common/enums/Routes';
import {Permissions} from '@simpleforyou/coaching-shared';
//================= [VUE COMPONENTS] ==========================

export const notificationRoutes = [
  {
    path: i18n.global.t('routes.notification'),
    name: Routes.NOTIFICATION,
    component: () => import('@/components/notification/NotificationList.vue'),
    meta: {
      title: i18n.global.t('titles.notification'),
      active: 'notification',
      roles: [Permissions.ROLE_NOTIFICATION_INDEX],
    },
  },
];
